import { TextField } from '@cambridgeassessment/cambridge-ui';
import React, { memo, useEffect, useState } from 'react';
import { useStyles } from './styles';

type Props = {
  label: string;
  password: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PasswordField: React.FC<Props> = ({ label, password, onChange }) => {
  const [showError, setShowError] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    setShowError(password.length === 0);
  }, [password]);

  useEffect(() => {
    setShowError(false);
  }, []);

  return (
    <TextField
      className={classes.passwordField}
      value={password}
      onChange={onChange}
      helperText={showError && 'The field is required.'}
      validationType={showError ? 'error' : null}
      label={label}
      type="password"
      data-testid="passwordField"
    />
  );
};

export default memo(PasswordField);
